import React, { useEffect, useState } from "react";
import instance from "../apiInstance";
import "./FavoritesManagement.css";

const money = (v) => {
  const n = Number(v);
  if (!n) return null;
  return `R$ ${n.toLocaleString("pt-BR", { minimumFractionDigits: 0 })}`;
};

const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR", {
      day: "2-digit", month: "2-digit", year: "2-digit",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

const ClientInterestsManagement = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [filter, setFilter] = useState("all"); // all | wish | genie
  const [clearingId, setClearingId] = useState(null);
  const [bulkMsg, setBulkMsg] = useState("");

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const params = { limit: 200 };
      if (filter === "wish") params.with_wish = true;
      if (filter === "genie") params.genie_only = true;
      const res = await instance.get("/admin/client-interests", { params });
      setClients(res.data?.clients || []);
    } catch (e) {
      setError("Erro ao carregar interesses: " + (e?.response?.data?.detail || e.message));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, [filter]); // eslint-disable-line

  const total = clients.length;
  const withWish = clients.filter((c) => c.wish_summary).length;
  const withSignals = clients.filter((c) => c.cart_signals_total > 0).length;
  const staleGenie = clients.filter((c) => c.stale_genie).length;

  const resetAllClients = async (apply) => {
    const msg = apply
      ? "Zerar personalização de TODAS as clientes (não admin)? Admins de teste mantêm."
      : "Simular: quem seria zerada?";
    if (!window.confirm(msg)) return;
    setBulkMsg("");
    try {
      const res = await instance.post("/admin/client-interests/reset-non-admin-wishes", null, {
        params: { apply },
      });
      const d = res.data || {};
      setBulkMsg(
        apply
          ? `Zeradas: ${d.cleared_count}. ${(d.cleared_emails || []).join(", ") || "nenhuma"}`
          : `Simulação: ${d.cleared_count} cliente(s) — ${(d.cleared_emails || []).join(", ") || "nenhuma"}`
      );
      if (apply) await load();
    } catch (e) {
      setBulkMsg(e?.response?.data?.detail || "Erro no reset em lote.");
    }
  };

  const clearWish = async (userId) => {
    if (!userId || !window.confirm("Limpar personalização ativa desta cliente? O feed volta ao normal.")) return;
    setClearingId(userId);
    try {
      await instance.post(`/admin/client-interests/${userId}/clear-promo-wish`);
      await load();
    } catch (e) {
      setError(e?.response?.data?.detail || "Não foi possível limpar.");
    } finally {
      setClearingId(null);
    }
  };

  return (
    <div className="fav-mgmt">
      <div className="fav-mgmt-header">
        <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>
          🧞 O que as clientes querem
        </h2>
        <p style={{ margin: "4px 0 0", fontSize: 13, color: "#666" }}>
          Desejos via Gênio + sinais de carrinho e feed. Atualizado em tempo real.
        </p>

        {/* KPIs */}
        <div style={{ display: "flex", gap: 16, marginTop: 12, flexWrap: "wrap" }}>
          {[
            { label: "Total clientes", value: total, color: "#d4a017" },
            { label: "Com desejo ativo", value: withWish, color: "#10b981" },
            { label: "Com sinais", value: withSignals, color: "#6366f1" },
            { label: "Personaliz. indevida", value: staleGenie, color: "#e53e3e" },
          ].map((k) => (
            <div key={k.label} style={{
              background: "#fff", border: "1px solid #f0e8d0", borderRadius: 10,
              padding: "8px 16px", minWidth: 110, textAlign: "center",
            }}>
              <div style={{ fontSize: 22, fontWeight: 700, color: k.color }}>{k.value}</div>
              <div style={{ fontSize: 11, color: "#888" }}>{k.label}</div>
            </div>
          ))}
        </div>

        {/* Filtros */}
        <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
          {[
            { key: "all", label: "Todas" },
            { key: "wish", label: "Só com desejo" },
            { key: "genie", label: "Só Gênio (abriu/editou)" },
          ].map((f) => (
            <button
              key={f.key}
              onClick={() => setFilter(f.key)}
              style={{
                padding: "5px 14px", borderRadius: 20, border: "1px solid #d4a017",
                background: filter === f.key ? "#d4a017" : "transparent",
                color: filter === f.key ? "#fff" : "#d4a017",
                fontWeight: 600, fontSize: 12, cursor: "pointer",
              }}
            >
              {f.label}
            </button>
          ))}
          <button onClick={load} style={{
            padding: "5px 14px", borderRadius: 20, border: "1px solid #ccc",
            background: "transparent", color: "#666", fontSize: 12, cursor: "pointer",
          }}>
            🔄 Atualizar
          </button>
          <button type="button" onClick={() => resetAllClients(false)} style={{
            padding: "5px 14px", borderRadius: 20, border: "1px solid #d4a017",
            background: "transparent", color: "#92600a", fontSize: 12, cursor: "pointer",
          }}>
            Ver quem zeraria
          </button>
          <button type="button" onClick={() => resetAllClients(true)} style={{
            padding: "5px 14px", borderRadius: 20, border: "1px solid #e53e3e",
            background: "#fff5f5", color: "#b91c1c", fontSize: 12, fontWeight: 600, cursor: "pointer",
          }}>
            Zerar clientes (não admin)
          </button>
        </div>
        {bulkMsg ? (
          <p style={{ marginTop: 8, fontSize: 12, color: "#444" }}>{bulkMsg}</p>
        ) : null}
      </div>

      {loading && (
        <div style={{ textAlign: "center", padding: 40, color: "#999" }}>Carregando...</div>
      )}
      {error && (
        <div style={{ color: "#e53e3e", padding: 16, background: "#fff5f5", borderRadius: 8, margin: "12px 0" }}>
          {error}
        </div>
      )}

      {!loading && !error && clients.length === 0 && (
        <div style={{ textAlign: "center", padding: 40, color: "#aaa" }}>
          Nenhuma cliente com desejo registrado ainda.
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 8 }}>
        {clients.map((c) => (
          <div key={c.user_id} style={{
            background: "#fff",
            border: c.wish_summary ? "1.5px solid #d4a017" : "1px solid #f0e8d0",
            borderRadius: 12,
            padding: "14px 16px",
          }}>
            {/* Cabeçalho do card */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 8 }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: 14 }}>
                  {c.name || c.email || "Sem nome"}
                </div>
                <div style={{ fontSize: 12, color: "#888" }}>
                  {c.email}{c.phone ? ` · ${c.phone}` : ""}
                </div>
              </div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {c.wish_summary && !c.wish_expired && (
                  <span style={{
                    background: "#d4f7e7", color: "#10b981", borderRadius: 12,
                    padding: "2px 10px", fontSize: 11, fontWeight: 600,
                  }}>
                    ✨ Desejo ativo
                  </span>
                )}
                {c.wish_expired && (
                  <span style={{
                    background: "#fff3cd", color: "#92600a", borderRadius: 12,
                    padding: "2px 10px", fontSize: 11, fontWeight: 600,
                  }}>
                    ⏰ Expirado
                  </span>
                )}
                {c.cart_signals_total > 0 && (
                  <span style={{
                    background: "#ede9fe", color: "#6366f1", borderRadius: 12,
                    padding: "2px 10px", fontSize: 11, fontWeight: 600,
                  }}>
                    🛒 {c.cart_signals_total} sinais
                  </span>
                )}
                {c.stale_genie && (
                  <span style={{
                    background: "#fee2e2", color: "#b91c1c", borderRadius: 12,
                    padding: "2px 10px", fontSize: 11, fontWeight: 600,
                  }}>
                    ⚠️ Feed pode bugar
                  </span>
                )}
              </div>
            </div>

            {/* Desejo explícito */}
            {c.wish_summary && (
              <div style={{
                marginTop: 10, background: "#fffbf0", borderRadius: 8,
                padding: "8px 12px", border: "1px solid #f0e8d0",
              }}>
                <div style={{ fontSize: 11, color: "#b8860b", fontWeight: 600, marginBottom: 2 }}>
                  🧞 Gênio da Promo
                </div>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{c.wish_summary}</div>
                {c.wish_budget && (
                  <div style={{ fontSize: 12, color: "#888", marginTop: 2 }}>
                    Teto: {money(c.wish_budget)}
                  </div>
                )}
                {c.wish_updated_at && (
                  <div style={{ fontSize: 11, color: "#aaa", marginTop: 2 }}>
                    Atualizado: {fmtDate(c.wish_updated_at)}
                  </div>
                )}
                {c.wish_history_count > 0 && (
                  <div style={{ fontSize: 11, color: "#aaa", marginTop: 2 }}>
                    {c.wish_history_count} edições salvas no histórico
                  </div>
                )}
                {(c.wish_summary || c.stale_genie) && (
                  <button
                    type="button"
                    disabled={clearingId === c.user_id}
                    onClick={() => clearWish(c.user_id)}
                    style={{
                      marginTop: 8, padding: "6px 12px", borderRadius: 8,
                      border: "1px solid #e53e3e", background: "#fff", color: "#b91c1c",
                      fontSize: 12, fontWeight: 600, cursor: "pointer",
                    }}
                  >
                    {clearingId === c.user_id ? "Limpando…" : "Limpar personalização"}
                  </button>
                )}
              </div>
            )}

            {c.genie_audit?.length > 0 ? (
              <div style={{ marginTop: 10, fontSize: 11, color: "#666" }}>
                <div style={{ fontWeight: 600, marginBottom: 4 }}>Rastro Gênio (clicou / editou)</div>
                <ul style={{ margin: 0, paddingLeft: 16 }}>
                  {[...c.genie_audit].reverse().map((ev, i) => (
                    <li key={`${ev.ts}-${i}`}>
                      {fmtDate(ev.ts)} — <strong>{ev.action || "—"}</strong>
                      {ev.detail?.surface ? ` (${ev.detail.surface})` : ""}
                      {ev.detail?.eligible === false ? " · sem permissão" : ""}
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}

            {/* Sinais implícitos (carrinho + feed) */}
            {(c.top_brands?.length > 0 || c.top_categories?.length > 0) && (
              <div style={{ marginTop: 10, display: "flex", gap: 16, flexWrap: "wrap" }}>
                {c.top_brands?.length > 0 && (
                  <div>
                    <div style={{ fontSize: 11, color: "#6366f1", fontWeight: 600, marginBottom: 4 }}>
                      Marcas que clicou
                    </div>
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                      {c.top_brands.map((b) => (
                        <span key={b.brand} style={{
                          background: "#ede9fe", color: "#4338ca",
                          borderRadius: 10, padding: "2px 8px", fontSize: 11,
                        }}>
                          {b.brand} ({b.count}×)
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                {c.top_categories?.length > 0 && (
                  <div>
                    <div style={{ fontSize: 11, color: "#6366f1", fontWeight: 600, marginBottom: 4 }}>
                      Categorias
                    </div>
                    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                      {c.top_categories.map((cat) => (
                        <span key={cat.category} style={{
                          background: "#f0fdf4", color: "#059669",
                          borderRadius: 10, padding: "2px 8px", fontSize: 11,
                        }}>
                          {cat.category} ({cat.count}×)
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Último sinal */}
            {c.last_signal_at && (
              <div style={{ fontSize: 11, color: "#bbb", marginTop: 8 }}>
                Último sinal: {fmtDate(c.last_signal_at)}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientInterestsManagement;
